module.exports = __webpack_public_path__ + "media/site_templates/www.rubbishremoval.company/images/our_services_1-e9d4e0479f5056b2435bd5dc8da074b2.jpg";